import { useOutletContext } from "react-router-dom";
import Backlog from "@/components/Backlog";

export default function BacklogPage() {
  const ctx = useOutletContext();
  return (
    <Backlog projectId={ctx.projectId} project={ctx.project} sprints={ctx.sprints}
      columns={ctx.columns} refreshKey={ctx.refreshKey}
      onOpenTask={ctx.openTask} onCreateTask={ctx.createTask} onChanged={ctx.bump} />
  );
}
